const ENABLER = 'sznivadbg';
const PERMANENT_ENABLER = 'sznivadbgsave';
const EVENT_PREFIX = 'iva_dbg_event_';
const DEFAULTS = {
    FCOLOR: 'white',
    BCOLOR: 'black',
};
export { ENABLER, EVENT_PREFIX, DEFAULTS, PERMANENT_ENABLER };
